import {useContext} from "react";
import {IPlayerPageContext} from "../contexts/models/IPlayerPageContext.ts";
import {PlayerPageContext} from "../contexts/PlayerPageContext.tsx";

export const usePlayerPage = () => {
    return useContext<IPlayerPageContext>(PlayerPageContext);
}